import React from 'react'
import InstallStatusCard from '@/modules/pwa/components/manage-app/InstallStatusCard'
import UpdatesCard from '@/modules/pwa/components/manage-app/UpdatesCard'
import PushTipsCard from '@/modules/pwa/components/manage-app/PushTipsCard'
import InstallInstructionsCard from '@/modules/pwa/components/manage-app/InstallInstructionsCard'
import InstallabilityDiagnosticsCard from '@/modules/pwa/components/manage-app/InstallabilityDiagnosticsCard'
import PushSettingsCard from '@/modules/pwa/components/PushSettingsCard'
import { manageAppAnchors } from '@/modules/pwa/utils/manageAppAnchors'

export default function ManageAppPage() {
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold">Gerenciar app</h1>
        <p className="text-sm text-foreground/70">
          Instalacao, atualizacoes e notificacoes para usar o Cripto Alert no desktop e no celular.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <InstallStatusCard />
        <UpdatesCard />
        <div id={manageAppAnchors.installabilityDiagnostics} className="md:col-span-2">
          <InstallabilityDiagnosticsCard />
        </div>
      </div>

      <div className="space-y-4">
        <PushSettingsCard />
        <PushTipsCard />
      </div>

      <div id={manageAppAnchors.installInstructions}>
        <InstallInstructionsCard />
      </div>
    </div>
  )
}
